<template>
  <div class="flex flex-col gap-4">
    <div v-for="part in parts">
      <input
        type="checkbox"
        name="partCode"
        :id="part.id"
        :key="part.id"
        :value="part.id"
        :checked="internalValue === part.id"
        class="peer hidden"
        @change="onChange(part.id, null, null, part.hasSubcategories, part.parentId ?? parentId, part.categoryLevel, part.name)"
      />
      <Label :val="part.id" :id="part.id" :name="part.name" :internalValue="internalValue" :onChange="onChange" />
    </div>
  </div>
</template>
<script>
import Label from '@/components/ui/label';
import { getMappedValue } from '@/helpers/mapper';
export default {
  name: 'ChoosePart',
  components: { Label },
  props: {
    areaCode: {
      required: true,
    },
    partCode: {
      required: false,
    },
    value: {
      required: false,
    },
    dir: {
      required: false
    },
    parentId: {
      required: false,
    },
    categoryLevel: {
      required: false,
    },
  },

  data() {
    return {
      showLoader: true,
      internalValue: null,
      previousCategoryLevel: "",
    };
  },

  watch: {
    value: {
      immediate: true,
      handler(value) {
        this.internalValue = value;
      },
    },

    parts: {
      immediate: true,
      handler(parts) {
        if (parts.length == 1 && parts[0].code) {
          this.onChange(parts[0].code);
        }
      },
    },
  },

  computed: {
    parts() {
      if (this.previousCategoryLevel == "four" || this.previousCategoryLevel == "three" || this.previousCategoryLevel == 1) return this.$store.getters.getSubCategories;
      else return this.$store.getters.getSubParts;

    },
    show() {
      return !!this.parts.length;
    },
  },
  methods: {
    onChange(val, id=null, floorPlanUrl=null, hasSubCat=null, parentId=null, categoryLevel, name) {
      if (this.internalValue === val) {
        this.internalValue = null;
        this.$emit('update:partCode', null);
        this.$emit('update:hasBottomNode', null);
//        this.$emit('update:parentId', null);
        this.$emit('part-selected', null)
  //      this.$emit('update:categoryLevel', null)
        this.$emit('update:partCodeName', null)
      } else {
        this.internalValue = val;
        this.$emit('update:partCode', val);
        this.$emit('update:hasBottomNode', hasSubCat);
        this.$emit('update:parentId', parentId);
        this.$emit('part-selected', val)
        this.$emit('update:categoryLevel', categoryLevel)
        this.$emit('update:partCodeName', name)
      }
    }


  },


  created() {
    this.previousCategoryLevel = this.categoryLevel;
    if (this.partCode && this.dir =="prev"){
      this.internalValue = this.partCode;
      this.$emit('part-selected', this.internalValue)
      this.$emit('update:partCode', this.internalValue);
    }
  },
};
</script>
